/**
 * The source's `services/dispositionsApi.ts`, read half only. Disposition Cost Analysis and
 * Benefit Realization call `listDispositions`; the finalize/clear calls write App
 * Rationalization's dispositions and no Program Planning screen uses them. Transport is
 * `authFetch` (session cookie) instead of the source's axios + bearer token.
 */
import { authFetch } from './api';

export interface AppDisposition {
  id: string;
  application_id_code?: string;
  application_name: string;
  vendor?: string;
  l1_business_functional_area?: string;
  l2_capability_function?: string;
  ai_initial_disposition?: string;
  ai_initial_run_id?: string;
  ai_initial_recorded_at?: string;
  manual_initial_disposition?: string;
  manual_initial_score?: number;
  manual_initial_recorded_at?: string;
  final_disposition?: string;
  final_disposition_source?: 'ai' | 'manual' | 'override';
  final_disposition_note?: string;
  finalized_by?: string;
  finalized_by_name?: string;
  finalized_at?: string;
}

export async function listDispositions(): Promise<AppDisposition[]> {
  const response = await authFetch("/api/dispositions");
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  return response.json();
}

export async function getDisposition(appId: string): Promise<AppDisposition> {
  const response = await authFetch(`/api/dispositions/${appId}`);
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  return response.json();
}
